<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div>
    <PageHeader title="Past claims" />

    <div v-if="claims?.length > 0">
      <Table
        :columns="columns"
        :data="claims"
        :isRowClickable="true"
        @rowClick="(row) => redirectToClaimDetailsPage(row.friendlyId)"
      >
        <template #id="{ row }">
          <div class="flex flex-col text-sm font-medium text-gray-900 sm:pl-6">
            <div class="flex items-center">
              <span>{{ row.friendlyId }}</span>
            </div>
            <div class="mt-2">
              <FieldSpan :style-to-add="statusStyle(row.status)" :value="$t(`claim.status.${row.status}`)" />
            </div>
            <div
              v-if="hasRequiredAction(row)"
              class="mt-2 inline-flex items-center px-2 py-1 rounded-md bg-yellow-100 border border-yellow-300 text-yellow-800 text-xs font-medium"
            >
              <ExclamationCircleIcon class="w-3 h-3 mr-1" />
              Une action est requise de votre part
            </div>
          </div>
        </template>
        <template #claimProduct="{ row }">
          <p>{{ row.claimProduct.title }}</p>
        </template>
      </Table>
    </div>
    <div v-else class="mt-4">
      <FolderAddIcon class="mx-auto h-12 w-12 text-gray-400" />
      <h1 class="mt-1 text-sm text-gray-500 text-center">
        {{ $t("No claims yet") }}
      </h1>
    </div>
  </div>
</template>

<script>
import { FolderAddIcon, ExclamationCircleIcon } from "@heroicons/vue/solid";
import { Table, FieldSpan, PageHeader } from "@estaly/ui";
import { mapGetters } from "vuex";

export default {
  components: {
    PageHeader,
    FieldSpan,
    FolderAddIcon,
    ExclamationCircleIcon,
    Table,
  },
  props: ["claims"],
  computed: {
    ...mapGetters("claims", ["hasRequiredAction", "statusStyle"]),

    columns() {
      return [
        {
          label: this.$t("Claim Id"),
          field: "friendlyId",
          slot: "id",
        },
        {
          label: "Produit",
          slot: "claimProduct",
          field: "claimProduct",
        },
        {
          label: "Date de déclaration",
          field: "filedDate",
        },
      ];
    },
  },
  methods: {
    redirectToClaimDetailsPage(friendlyId) {
      this.$router.push(`/claims/${friendlyId}`);
    },
  },
};
</script>
